export const ISCC_POS_26 = "ISCC PoS 2.6";
export const ISCC_SD_26 = "ISCC SD 2.6";
export const ISCC_PLUS_BP_MARKETING = "BP Marketing";
export const ISCC_PLUS_351 = "ISCC Plus 3.5.1";
export const ISCC_EU = "ISCC EU";
export const ISCC_PLUS = "ISCC PLUS";

export default {ISCC_SD_26};
